/**
 * Opções globais de imagem de produto na loja (todos os layouts).
 * @param {{
 *   json: string,
 *   onJsonChange: (s: string) => void,
 *   disabled?: boolean,
 * }} props
 */
export function StoreProductDisplayForm({ json, onJsonChange, disabled = false }) {
  let body = { sectionPhotoFallback: false };
  try {
    const o = JSON.parse(json.trim() === '' ? '{}' : json);
    if (o && typeof o === 'object' && !Array.isArray(o)) {
      body = {
        sectionPhotoFallback: Boolean(o.sectionPhotoFallback),
      };
    }
  } catch {
    /* mantém defaults */
  }

  function patch(key, value) {
    onJsonChange(JSON.stringify({ ...body, [key]: value }, null, 2));
  }

  return (
    <div className="space-y-3 rounded-xl border border-teal-700/20 bg-teal-500/[0.06] p-4 dark:border-teal-400/20 dark:bg-teal-500/[0.08]">
      <p className="text-xs font-semibold uppercase tracking-wide text-teal-900 dark:text-teal-200">
        Imagens na loja (todos os layouts)
      </p>
      <label className="flex cursor-pointer items-start gap-3 text-sm text-ink dark:text-mist">
        <input
          type="checkbox"
          checked={body.sectionPhotoFallback}
          disabled={disabled}
          onChange={(e) => patch('sectionPhotoFallback', e.target.checked)}
          className="mt-0.5 h-4 w-4 rounded border-ink/30 text-teal-600 focus:ring-teal-500 dark:border-white/25"
        />
        <span>
          <span className="font-semibold">Usar foto da secção quando o produto não tiver foto</span>
          <span className="mt-0.5 block text-xs font-normal text-ink/65 dark:text-mist/65">
            Vale para grelha, vitrine, formato lista, catálogo luxo e modal de fotos. Se a secção também não tiver
            foto, mantém o comportamento actual (inicial do nome ou «sem foto»).
          </span>
        </span>
      </label>
    </div>
  );
}
